import { CardConfig, CardType, MonsterType, StatType } from "../entities/CardTypes";

type Loop = {
    startingDeck?: CardConfig[]
}

export const startRoomCount = 3 // Без учёта комнаты босса
export const loopIncRoomCount = 3

const sanctuareChance: number = 0.70;
const maxForges: number = 4 // Максимальное количество Кузнец
let forgesCount: number = 1 // Текущее количество Кузнец (с учётом выданой на старте)

export function generateRandomDeck() {
    const deck: CardConfig[] = []

    if (Math.random() < (maxForges - forgesCount) / maxForges) {
        forgesCount++
        deck.push({
            type: CardType.INCREASE_STAT,
            statType: StatType.FORGE
        })
    }

    if (Math.random() < sanctuareChance) {
        deck.push({
            type: CardType.INCREASE_STAT,
            statType: StatType.SANCTUARY
        })
    }

    while (deck.length < loopIncRoomCount) { // Дозаполняем карточки монтрами
        deck.push({
            type: CardType.CREATE_MONSTER,
            monsterType: generateRandomMonster(),
        })
    }

    return deck
}

const generateRandomMonster = () => {
    const monsterIndex = Math.floor(Math.random() * 1) // TODO: умножаем на количество типов монстров
    switch (monsterIndex) {

        default: return MonsterType.SIMPLE
    }
}

export const Loops: Loop[] =
    [
        {
            startingDeck: [
                {
                    type: CardType.CREATE_MONSTER,
                    monsterType: MonsterType.SIMPLE,
                },
                {
                    type: CardType.CREATE_MONSTER,
                    monsterType: MonsterType.SIMPLE,
                },
                {
                    type: CardType.INCREASE_STAT,
                    statType: StatType.SANCTUARY,
                },
            ]
        },
        {
            startingDeck: [
                {
                    type: CardType.CREATE_MONSTER,
                    monsterType: MonsterType.SIMPLE,
                },
                {
                    type: CardType.INCREASE_STAT,
                    statType: StatType.SANCTUARY,
                },
                {
                    type: CardType.INCREASE_STAT,
                    statType: StatType.FORGE,
                }
            ]
        },
        {
            startingDeck: undefined
        }
    ]